
import getInfoSize from "./getInfoSize";
import pdfGeneratingModal from "../../components/modal/pdfGeneratingModal";
import pdfPrepareModal from "../../components/modal/pdfPrepareModal";

let companyNameA = "";
let companyNameB = "";
let yj = "";
let zff = "";

export default function generateJJXX(type,data){
  app.modal.show(pdfPrepareModal,{callback:function(prepareData){
    companyNameA = prepareData.companyNameA;
    companyNameB = prepareData.companyNameB;
    yj = prepareData.yj;
    zff = prepareData.zff;

    app.modal.show(pdfGeneratingModal);
  
    let jspdfFont = document.createElement('script');
    jspdfFont.src = './assets/extensions/ziiven-u2di/font/source-han-sans-normal.js';
    document.head.appendChild(jspdfFont);
  
    let jspdfFontBold = document.createElement('script');
    jspdfFontBold.src = './assets/extensions/ziiven-u2di/font/source-han-sans-heavy.js';
    document.head.appendChild(jspdfFontBold);
  
    let resourceLoadedCount = 0;
    let resourceTotalCount = 2;
  
    const infoBaseData = data.infoBaseData;
    const infoUserID = infoBaseData.userID();
  
    if(type==="distribute"){
      const distributeUserID = data.distributeUserID;
  
      resourceTotalCount = 3;
  
      app.store
        .find("u2diUserPrivateInfo", {
          userID:distributeUserID,
      })
      .catch(() => {})
      .then((result)=>{
        resourceLoadedCount++;
        data.distributeUserPrivateData = result[0];
        process(type,data,resourceLoadedCount,resourceTotalCount);
      });
      
      if(infoUserID!==null){
        resourceTotalCount = 4;
  
        app.store
          .find("u2diUserPrivateInfo", {
            userID:infoUserID,
        })
        .catch(() => {})
        .then((result)=>{
          resourceLoadedCount++;
          data.infoUserPrivateData = result[0];
          process(type,data,resourceLoadedCount,resourceTotalCount);
        });
      }
    }else if(type==="query"){
      if(infoUserID===null){
        process(type,data,resourceLoadedCount,resourceTotalCount);
      }else{
        resourceTotalCount = 3;
  
        app.store
          .find("u2diUserPrivateInfo", {
            userID:infoUserID,
        })
        .catch(() => {})
        .then((result)=>{
          resourceLoadedCount++;
          data.infoUserPrivateData = result[0];
          process(type,data,resourceLoadedCount,resourceTotalCount);
        });
      }
    }
  
    jspdfFontBold.onload = function(){
      resourceLoadedCount++;
      process(type,data,resourceLoadedCount,resourceTotalCount);
    }
  
    jspdfFont.onload = function(){
      resourceLoadedCount++;
      process(type,data,resourceLoadedCount,resourceTotalCount);
    }
  }});
};

function process(type,data,resourceLoadedCount,resourceTotalCount){
    if(resourceLoadedCount<resourceTotalCount){
      return;
    }

    const { jsPDF } = window.jspdf;
    const infoBaseData = data.infoBaseData;
    const infoDetailsData = data.infoDetailsData;

    const infoUserID = infoBaseData.userID();
    const infoSN = infoBaseData.sn();
    const infoCategory = infoBaseData.category();
    const info_zcxx = JSON.parse(infoDetailsData.zcxx());
    const info_jjxx = JSON.parse(infoDetailsData.jjxx());
    let slotCount = 0;
    let U2DiAccountNameList = [];

    if(type==="distribute"){
      if(infoUserID===null){
        slotCount = 2;
        U2DiAccountNameList = [app.forum.attribute('U2DiAccountName'),data.distributeUserPrivateData.zsxm()];
      }else{
        slotCount = 3;
        U2DiAccountNameList = [data.infoUserPrivateData.zsxm(),app.forum.attribute('U2DiAccountName'),data.distributeUserPrivateData.zsxm()];
      }
    }else if(type==="query"){
      if(infoUserID===null){
        slotCount = 1;
        U2DiAccountNameList = [app.forum.attribute('U2DiAccountName')];
      }else{
        slotCount = 2;
        U2DiAccountNameList = [app.forum.attribute('U2DiAccountName'),data.infoUserPrivateData.zsxm()];
      }
    }
    
    const option_jzmj = info_zcxx.option_jzmj;
    const option_tdmj = info_zcxx.option_tdmj;
    const option_jjbl = info_jjxx.option_jjbl;

    const infoProvince = infoBaseData.province();
    const infoCity = infoBaseData.city();
    const infoLocationText =  (infoProvince && infoProvince!==infoCity?infoProvince:"")+""+infoCity;

    const option_zcqs = app.translator.trans("ziven-u2di.forum.option-zcqs-"+info_zcxx.option_zcqs)
    const option_lzxz = app.translator.trans("ziven-u2di.forum.option-lzxz-"+info_zcxx.option_lzxz);
    const option_zclb = app.translator.trans("ziven-u2di.forum.option-zclb-"+info_zcxx.option_zclb);

    let doc = new jsPDF();
    let y = 10;
    let x = 25;
    doc.addFont('SourceHanSans-Normal.ttf', 'SourceHanSans-Normal', 'normal');
    doc.addFont('SourceHanSans-Heavy.ttf', 'SourceHanSans-Heavy','bold');

    doc.saveGraphicsState();
    doc.setGState(new doc.GState({opacity: 0.4}));
    doc.addImage("./assets/extensions/ziiven-u2di/promotionImageLogo.png", "PNG", 30, 50, 452*0.33, 90*0.33,"","NONE",-30);
    doc.restoreGraphicsState();

    doc.setFont('SourceHanSans-Heavy', "bold");
    doc.setFontSize(20);

    y+=20;
    doc.text("信息劳务费支付承诺协议书", 105, y, null, null, "center");

    doc.setFont('SourceHanSans-Normal', "normal");
    doc.setFontSize(11);

    y+=20;
    doc.text("委 托 方（甲方）："+companyNameA, x, y);
    y+=7;
    doc.text("收 购 方（乙方）："+companyNameB, x, y);
    y+=7;
    doc.text("居 间 方（丙方：「优土地｜www.u2di.com」）："+U2DiAccountNameList.join("　"), x, y);
    y+=7;
    doc.text("资产编号："+infoSN+"（可在「优土地｜www.u2di.com」系统中查询该编号资产详情）", x, y);

    let infoAreaSize = "";
    let infoAreaUnit = "";

    if(infoCategory==="jzwz"){
        infoAreaSize = option_jzmj;
        infoAreaUnit = app.translator.trans('ziven-u2di.lib.unit-squre-meter');
    }else if(infoCategory==="tdwz"){
        infoAreaSize = option_tdmj;
        infoAreaUnit = app.translator.trans('ziven-u2di.lib.unit-mu');
    }

    infoAreaSize = getInfoSize(infoAreaSize,"valueOnly");

    const infoName = option_zcqs+" "+option_lzxz+" "+option_zclb;

    y+=7;
    doc.text("项目概况："+infoLocationText+" "+infoAreaSize+infoAreaUnit+" "+infoName, x, y);

    y+=15;
    doc.text("一、以合同签署为准，本协议即时生效。", x, y);
    y+=7;
    doc.text("二、居间方「优土地｜www.u2di.com」为甲乙双方提供该项目的信息推广、咨询接洽、成交撮合。", x, y);
    y+=7;
    doc.text("1，信息推广：甲方委托优土地就该项目信息，在优土地网站及渠道范围内进行推广。", x+7, y);
    y+=7;
    doc.text("2，咨询接洽：在甲方提供的信息范围内，响应乙方对该项目的咨询及答疑。", x+7, y);
    y+=7;
    doc.text("3，成交撮合：对接甲乙双方，撮合双方达成初步意向，为双方安排视频会及见面会。", x+7, y);
    y+=7;
    doc.text("三、委托方、收购方共同决定，同意经由居间方「优土地｜www.u2di.com」的撮合，并成功签署", x, y);
    y+=7;
    doc.text("合同，将合同（□ 总额的 "+(yj===""?option_jjbl+"%":"　　　　")+"　□ "+(yj===""?"　　　　":yj)+"万/亩 溢价）作为信息劳务费。", x-7, y);

    if(yj===""){
      doc.text("√", x+20, y);
    }else{
      doc.text("√", x+58.7, y);
    }

    y+=7;
    doc.text("四、委托方、收购方共同决定，并确认信息劳务费的支付方为："+zff+" 。支付方需按以下约定", x, y);
    y+=7;
    doc.text("方式向居间方支付信息劳务费（税费由支付方代扣代缴）。", x-7, y);
    y+=7;
    doc.text("依据签署的合同：第一笔款项到位后的2个工作日内支付全额的信息劳务费。", x+7, y);
    y+=7;
    doc.text("由支付方财务直接以现金或转账方式按比例足额打入居间方以下指定个人银行卡号。", x+7, y);

    y+=7;
    doc.setDrawColor(0);

    const slotWidth = 53;
    const slotHeight = 40;
    for(let i=0;i<3;i++){
      doc.setDrawColor(0, 0, 0);

      if(i>=slotCount){
        doc.setDrawColor(0, 0, 0,0.5);
      }

      let positionX = x-3+(i*56);
      let positionY = y;
      doc.roundedRect(positionX, positionY, slotWidth, slotHeight, 3, 3, "S");

      if(type==="distribute"){
        if(slotCount===2){
          showTypeD2(doc,positionX,positionY,slotWidth,slotHeight,i,data);
        }else if(slotCount===3){
          showTypeD3(doc,positionX,positionY,slotWidth,slotHeight,i,data);
        }
      }else if(type==="query"){
        if(slotCount===1){
          showTypeQ1(doc,positionX,positionY,slotWidth,slotHeight,i,data);
        }else if(slotCount===2){
          showTypeQ2(doc,positionX,positionY,slotWidth,slotHeight,i,data);
        }
      }
    }

    y+=50;
    doc.text("五、收取本项目信息劳务费时居间方不需办理任何收款凭证，支付方无条件提供给居间方完税证", x, y);
    y+=7;
    doc.text("明。信息劳务费的税费由支付方代扣代缴;若涉及税费的法律或经济责任，均由支付方负责承担。", x-7, y);
    y+=7;
    doc.text("六、只要是成功签署了合同即表示该项目撮合成功，支付方无条件按照本协议的约定支付居间方", x, y);
    y+=7;
    doc.text("的信息劳务费。居间方保留维护自己利益的各种权利和方式，维护权利过程中产生的一切费用和法律", x-7, y);
    y+=7;
    doc.text("后果均由支付方负责。", x-7, y);
    y+=7;
    doc.text("七、若支付方恶意逃避支付居间方信息劳务费或故意找任何借又拖延支付居间方的信息劳务费，", x, y);
    y+=7;
    doc.text("均属支付方违约，支付方将无条件接受下列处置，并放弃一切抗辩权利：1，居间方可凭此承诺协议", x-7, y);

    doc.addPage();
    doc.saveGraphicsState();
    doc.setGState(new doc.GState({opacity: 0.4}));
    doc.addImage("./assets/extensions/ziiven-u2di/promotionImageLogo.png", "PNG", 30, 50, 452*0.33, 90*0.33,"","NONE",-30);
    doc.restoreGraphicsState();

    y=30;
    doc.text("书依法冻结支付方的银行账号;2，本承诺协议书自动转为支付方欠居间方信息劳务费的欠条，追回", x-7, y);
    y+=7;
    doc.text("未兑现的信息劳务费并按该费用的总额加收每日3‰的滞纳金;3，按信息劳务费总额的两倍收取罚", x-7, y);
    y+=7;
    doc.text("金;4，追索期间所产生的一切费用(包含但不限于律师费、诉讼费、执行费、财产保全费、公证费、", x-7, y);
    y+=7;
    doc.text("违约金、罚金、差旅费等费用)均由支付方承担。", x-7, y);
    y+=7;
    doc.text("八、委托方、收购方签署合同后发生任何纠纷，由此产生的一切经济和法律纠纷，支付方承诺付", x, y);
    y+=7;
    doc.text("给居间方的信息劳务费均无需退还，如产生任何经济或法律责任，由支付方承担一切经济和法律责", x-7, y);
    y+=7;
    doc.text("任，与居间方无任何关联。居间方有义务及责任配合委托方、收购方处理相关问题。", x-7, y);
    y+=7;
    doc.text("九、本承诺协议书为不可撤销，在本承诺协议书生效后的过程中，委托方和收购方之间违约均与", x, y);
    y+=7;
    doc.text("居间方无关，居间方不需要承担任何经济和法律责任，与支付方其他相关承诺不相抵触，独立执行，", x-7, y);
    y+=7;
    doc.text("不受企业改制，更名或更换法定代表人或增、减、换股东而影响，本承诺协议书确认的支付方签字盖", x-7, y);
    y+=7;
    doc.text("章生效，具有永久法律效力。委托方、收购方的法定代表人(或授权委托人)为本承诺协议书担保支", x-7, y);
    y+=7;
    doc.text("付的保证人，承担连带保证责任。本承诺协议书居间人可以继承，当居间方将自己的居间费继承给自", x-7, y);
    y+=7;
    doc.text("己的亲属时，必须以书面形式通知支付方，同时支付方应给予居间继承人书面认可并签字。", x-7, y);
    y+=7;
    doc.text("十、本承诺协议书经委托方、收购方一致通过并同意，其法定代表人(或授权委托人)如实填写", x, y);
    y+=7;
    doc.text("并签字(盖公章)即为生效。本承诺协议书三方各执一份，承诺协议书电子扫描件、传真件和本项目", x-7, y);
    y+=7;
    doc.text("所涉及的相关文件资料的复印件、传真件、电子件、扫描件等，均与原件具有同等效力。", x-7, y);
    y+=7;
    doc.text("十一、若续签后续合同，委托方、收购方承诺一切按上述协议标准执行。", x, y);
    y+=7;
    doc.text("十二、争议解决方式", x, y);
    y+=7;
    doc.text("1、如发生争议，协商解决;协商不成则任何一方均可向居间方所在地人民法院提起诉讼。", x+7, y);
    y+=7;
    doc.text("2、除非三方协商一致或本协议约定外，任何一方均不得单方擅自终止协议。", x+7, y);
    let currentTime = new Date();
    let year = currentTime.getFullYear();
    let month = currentTime.getMonth() + 1;
    let day = currentTime.getDate();

    if(month<10){ month = "0"+month; }
    if(day<10){ day = "0"+day; }

    y+=15;
    doc.text("特此承诺", x, y);
    y+=20;
    doc.text("委 托 方（甲方公章）：", x, y);
    y+=15;
    doc.text("居 间 方：", x+100, y);

    doc.saveGraphicsState();
    doc.setGState(new doc.GState({opacity: 0.9}));
    doc.addImage("./assets/extensions/ziiven-u2di/signature.png", "PNG", x+120, y-10, 94/5, 87/5,"","NONE",0);
    doc.restoreGraphicsState();

    y+=15;
    doc.text("收 购 方（乙方公章）：", x, y);
    y+=30;
    doc.text("承诺日期： "+year+" 年 "+month+" 月 "+day+" 日", x, y);

    doc.save('居间协议-'+infoSN+'.pdf');
    window.open(doc.output('bloburl'));
    app.modal.close();
}

function showTypeD2(doc,x,y,width,height,slotID,data){
  if(slotID===0){
    const U2DiAccountName = app.forum.attribute('U2DiAccountName');
    const U2DiIdentificationID = app.forum.attribute('U2DiIdentificationID');
    const U2DiAccountBank = app.forum.attribute('U2DiAccountBank');
    const U2DiAccountNumber = app.forum.attribute('U2DiAccountNumber');

    doc.text(U2DiAccountName+" 占比：50%", x+width/2, y+7, null, null, "center");

    doc.setFontSize(10);
    doc.text("户　名："+U2DiAccountName, x+1, y+17);
    doc.text("身份证："+U2DiIdentificationID, x+1, y+22);

    let yModifier = 0;
    if(U2DiAccountBank.length>10){
      const line1 = U2DiAccountBank.slice(0,10);
      const line2 = U2DiAccountBank.slice(10);
      doc.text("开户行："+line1, x+1, y+27);
      doc.text("　　　　"+line2, x+1, y+32);
      yModifier = 5;
    }else{
      doc.text("开户行："+U2DiAccountBank, x+1, y+27);
    }

    doc.text("账　号："+U2DiAccountNumber, x+1, y+32+yModifier);
    doc.setFontSize(11);
  }else if(slotID===1){
    const distributeUserPrivateData = data.distributeUserPrivateData;
    const key = distributeUserPrivateData.key();
    const distributeUserAccountName = distributeUserPrivateData.zsxm();
    const distributeUserIdentificationID = CryptoJSAesJson.decrypt(distributeUserPrivateData.sfzh(), key);
    const distributeUserAccountBank = CryptoJSAesJson.decrypt(distributeUserPrivateData.khh(), key);
    const distributeUserAccountNumber = CryptoJSAesJson.decrypt(distributeUserPrivateData.yhkh(), key);

    doc.text(distributeUserAccountName+" 占比：50%", x+width/2, y+7, null, null, "center");

    doc.setFontSize(10);
    doc.text("户　名："+distributeUserAccountName, x+1, y+17);
    doc.text("身份证："+distributeUserIdentificationID, x+1, y+22);

    let yModifier = 0;
    if(distributeUserAccountBank.length>10){
      const line1 = distributeUserAccountBank.slice(0,10);
      const line2 = distributeUserAccountBank.slice(10);
      doc.text("开户行："+line1, x+1, y+27);
      doc.text("　　　　"+line2, x+1, y+32);
      yModifier = 5;
    }else{
      doc.text("开户行："+distributeUserAccountBank, x+1, y+27);
    }

    doc.text("账　号："+distributeUserAccountNumber, x+1, y+32+yModifier);
    doc.setFontSize(11);
  }
}

function showTypeD3(doc,x,y,width,height,slotID,data){
  if(slotID===0){
    const infoUserPrivateData = data.infoUserPrivateData;
    const key = infoUserPrivateData.key();
    const infoUserUserAccountName = infoUserPrivateData.zsxm();

    const infoUserUserIdentificationID = CryptoJSAesJson.decrypt(infoUserPrivateData.sfzh(), key);
    const infoUserUserAccountBank = CryptoJSAesJson.decrypt(infoUserPrivateData.khh(), key);
    const infoUserUserAccountNumber = CryptoJSAesJson.decrypt(infoUserPrivateData.yhkh(), key);

    doc.text(infoUserUserAccountName+" 占比：35%", x+width/2, y+7, null, null, "center");

    doc.setFontSize(10);
    doc.text("户　名："+infoUserUserAccountName, x+1, y+17);
    doc.text("身份证："+infoUserUserIdentificationID, x+1, y+22);

    let yModifier = 0;
    if(infoUserUserAccountBank.length>10){
      const line1 = infoUserUserAccountBank.slice(0,10);
      const line2 = infoUserUserAccountBank.slice(10);
      doc.text("开户行："+line1, x+1, y+27);
      doc.text("　　　　"+line2, x+1, y+32);
      yModifier = 5;
    }else{
      doc.text("开户行："+infoUserUserAccountBank, x+1, y+27);
    }

    doc.text("账　号："+infoUserUserAccountNumber, x+1, y+32+yModifier);
    doc.setFontSize(11);
  }else if(slotID===1){
    const U2DiAccountName = app.forum.attribute('U2DiAccountName');
    const U2DiIdentificationID = app.forum.attribute('U2DiIdentificationID');
    const U2DiAccountBank = app.forum.attribute('U2DiAccountBank');
    const U2DiAccountNumber = app.forum.attribute('U2DiAccountNumber');

    doc.text(U2DiAccountName+" 占比：30%", x+width/2, y+7, null, null, "center");

    doc.setFontSize(10);
    doc.text("户　名："+U2DiAccountName, x+1, y+17);
    doc.text("身份证："+U2DiIdentificationID, x+1, y+22);

    let yModifier = 0;
    if(U2DiAccountBank.length>10){
      const line1 = U2DiAccountBank.slice(0,10);
      const line2 = U2DiAccountBank.slice(10);
      doc.text("开户行："+line1, x+1, y+27);
      doc.text("　　　　"+line2, x+1, y+32);
      yModifier = 5;
    }else{
      doc.text("开户行："+U2DiAccountBank, x+1, y+27);
    }

    doc.text("账　号："+U2DiAccountNumber, x+1, y+32+yModifier);
    doc.setFontSize(11);
  }else if(slotID===2){
    const distributeUserPrivateData = data.distributeUserPrivateData;
    const key = distributeUserPrivateData.key();
    const distributeUserAccountName = distributeUserPrivateData.zsxm();

    const distributeUserIdentificationID = CryptoJSAesJson.decrypt(distributeUserPrivateData.sfzh(), key);
    const distributeUserAccountBank = CryptoJSAesJson.decrypt(distributeUserPrivateData.khh(), key);
    const distributeUserAccountNumber = CryptoJSAesJson.decrypt(distributeUserPrivateData.yhkh(), key);

    doc.text(distributeUserAccountName+" 占比：35%", x+width/2, y+7, null, null, "center");

    doc.setFontSize(10);
    doc.text("户　名： "+distributeUserAccountName, x+1, y+18);
    doc.text("身份证： "+distributeUserIdentificationID, x+1, y+23);
    doc.text("开户行： "+distributeUserAccountBank, x+1, y+28);
    doc.text("账　号： "+distributeUserAccountNumber, x+1, y+33);
    doc.setFontSize(11);
  }
}

function showTypeQ1(doc,x,y,width,height,slotID,data){
  if(slotID===0){
    const U2DiAccountName = app.forum.attribute('U2DiAccountName');
    const U2DiIdentificationID = app.forum.attribute('U2DiIdentificationID');
    const U2DiAccountBank = app.forum.attribute('U2DiAccountBank');
    const U2DiAccountNumber = app.forum.attribute('U2DiAccountNumber');

    doc.text(U2DiAccountName+" 占比：100%", x+width/2, y+7, null, null, "center");

    doc.setFontSize(10);
    doc.text("户　名："+U2DiAccountName, x+1, y+17);
    doc.text("身份证："+U2DiIdentificationID, x+1, y+22);

    let yModifier = 0;
    if(U2DiAccountBank.length>10){
      const line1 = U2DiAccountBank.slice(0,10);
      const line2 = U2DiAccountBank.slice(10);
      doc.text("开户行："+line1, x+1, y+27);
      doc.text("　　　　"+line2, x+1, y+32);
      yModifier = 5;
    }else{
      doc.text("开户行："+U2DiAccountBank, x+1, y+27);
    }

    doc.text("账　号："+U2DiAccountNumber, x+1, y+32+yModifier);
    doc.setFontSize(11);
  }
}

function showTypeQ2(doc,x,y,width,height,slotID,data){
  if(slotID===0){
    const U2DiAccountName = app.forum.attribute('U2DiAccountName');
    const U2DiIdentificationID = app.forum.attribute('U2DiIdentificationID');
    const U2DiAccountBank = app.forum.attribute('U2DiAccountBank');
    const U2DiAccountNumber = app.forum.attribute('U2DiAccountNumber');

    doc.text(U2DiAccountName+" 占比：50%", x+width/2, y+7, null, null, "center");

    doc.setFontSize(10);
    doc.text("户　名："+U2DiAccountName, x+1, y+17);
    doc.text("身份证："+U2DiIdentificationID, x+1, y+22);

    let yModifier = 0;
    if(U2DiAccountBank.length>10){
      const line1 = U2DiAccountBank.slice(0,10);
      const line2 = U2DiAccountBank.slice(10);
      doc.text("开户行："+line1, x+1, y+27);
      doc.text("　　　　"+line2, x+1, y+32);
      yModifier = 5;
    }else{
      doc.text("开户行："+U2DiAccountBank, x+1, y+27);
    }

    doc.text("账　号："+U2DiAccountNumber, x+1, y+32+yModifier);
    doc.setFontSize(11);
  }else if(slotID===1){
    const infoUserPrivateData = data.infoUserPrivateData;
    const key = infoUserPrivateData.key();
    const infoUserUserAccountName = infoUserPrivateData.zsxm();

    const infoUserUserIdentificationID = CryptoJSAesJson.decrypt(infoUserPrivateData.sfzh(), key);
    const infoUserUserAccountBank = CryptoJSAesJson.decrypt(infoUserPrivateData.khh(), key);
    const infoUserUserAccountNumber = CryptoJSAesJson.decrypt(infoUserPrivateData.yhkh(), key);

    doc.text(infoUserUserAccountName+" 占比：50%", x+width/2, y+7, null, null, "center");

    doc.setFontSize(10);
    doc.text("户　名："+infoUserUserAccountName, x+1, y+17);
    doc.text("身份证："+infoUserUserIdentificationID, x+1, y+22);

    let yModifier = 0;
    if(infoUserUserAccountBank.length>10){
      const line1 = infoUserUserAccountBank.slice(0,10);
      const line2 = infoUserUserAccountBank.slice(10);
      doc.text("开户行："+line1, x+1, y+27);
      doc.text("　　　　"+line2, x+1, y+32);
      yModifier = 5;
    }else{
      doc.text("开户行："+infoUserUserAccountBank, x+1, y+27);
    }

    doc.text("账　号："+infoUserUserAccountNumber, x+1, y+32+yModifier);

    doc.setFontSize(11);
  }
}